import AppRoutes from './AppRoutes';
import { Switch, Route } from 'react-router-dom';
import LoadingScreen from '../components/LoadingScreen';
import React, { Suspense, Fragment, lazy } from 'react';
import { PATH_PAGE, PATH_APP } from './paths';
import GuestProtect from 'src/components/Auth/GuestProtect';
import AuthProtect from 'src/components/Auth/AuthProtect';
import TopBarWithSignUp from 'src/layout/TopBarWithSignUp';
import Page404View from 'src/views/Page404View/index';

// ----------------------------------------------------------------------

export function renderRoutes(routes = []) {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? (
                      renderRoutes(route.routes)
                    ) : (
                      <Suspense fallback={<LoadingScreen />}>
                        <Component {...props} />
                      </Suspense>
                    )}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
        <Route component={Page404View} />
      </Switch>
    </Suspense>
  );
}

const routes = [
  {
    exact: true,
    // guard: GuestProtect,
    path: '/',
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    path: '/companyInfo/:jobId',
    component: lazy(() =>
      import('src/views/OpportunitiesView/ViewApplication/PreviewCompany.jsx')
    )
  },
  {
    exact: true,
    // guard: GuestProtect,
    path: PATH_PAGE.auth.login,
    // layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/auth/LoginView'))
  },
  {
    exact: true,
    // guard: GuestProtect,
    path: PATH_PAGE.auth.register,
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/auth/RegisterView'))
  },
  {
    exact: true,
    path: '/talentCard/:id',
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/TalentCardView/PublicTalentCard'))
  },
  {
    exact: true,
    path: '/posts/shareLink/:shareLink',
    layout: TopBarWithSignUp,
    component: lazy(() =>
      import('src/views/Communities/CenterTab/Post/SharedPost')
    )
  },
  {
    exact: true,
    guard: GuestProtect,
    path: PATH_PAGE.auth.forgetPassword,
    component: lazy(() => import('src/views/auth/ForgetPasswordView'))
  },
  {
    exact: true,
    guard: GuestProtect,
    path: PATH_PAGE.auth.resetPassword,
    component: lazy(() => import('src/views/auth/ResetPasswordView'))
  },
  {
    exact: true,
    path: PATH_PAGE.auth.talentDetails,
    component: lazy(() => import('src/views/auth/MultistepForm/MultiStep'))
  },
  {
    exact: true,
    path: PATH_PAGE.auth.googleLoginAndRegister,
    component: lazy(() => import('src/views/auth/SocialLoginAndRegisterr'))
  },
  {
    exact: true,
    path: PATH_PAGE.auth.emailValidate,
    component: lazy(() =>
      import('src/views/auth/EmailVerification/EmailVerification')
    )
  },
  {
    exact: true,
    path: '/carousel',
    component: lazy(() => import('src/views/CarouselView'))
  },
  {
    exact: true,
    path: '/verification-link', // Change to your verification link path
    component: lazy(() =>
      import('src/components/Verification/VerificationPage')
    )
  },
  {
    exact: true,
    guard: AuthProtect,
    path: '/interview',
    component: lazy(() => import('src/views/AudioInterview'))
  },
  {
    exact: true,
    path: '/claim-profile/:token',
    component: lazy(() => import('src/views/auth/ClaimProfile'))
  },
  {
    exact: true,
    path: '/jobTabs',
    component: lazy(() => import('src/views/OpportunitiesTabs/JobTabs'))
  },

  {
    exact: true,
    // guard: GuestProtect,
    path: '/communities',
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/Communities/Communities'))
  },
  {
    exact: true,
    // guard: GuestProtect,
    path: '/communities/:name/:id',
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/Communities/Communities2'))
  },
  {
    exact: true,
    // guard: GuestProtect,
    path: '/communities/all',
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/Communities/Communities3'))
  },

  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/Page404View/index'))
  },
  {
    exact: true,
    path: '/opportunities/:id',
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/OpportunitiesView/OpportunityCard'))
  },

  {
    exact: true,
    path: '/job/:jobId/assignment',
    layout: TopBarWithSignUp,
    component: lazy(() =>
      import('src/views/OpportunitiesView/GetCurated/CompanyDetailPublic')
    )
  },
  {
    exact: true,
    guard: AuthProtect,
    path: '/opportunities',
    layout: TopBarWithSignUp,
    component: lazy(() => import('src/views/OpportunitiesTabs/JobTabs'))
  },
  // App Routes
  AppRoutes

  // Home Routes
];

export default routes;
